import Client from './client/TrackingDynamicClient';

export default {
    async postTrackingDynamic(data) {
                                        // return  Client.post(`api/v1/tracking-dynamic`, data);
                                    },
};
